
const contactUsFormModalAgent = "Agent";
const contactUsFormModalHomebuyer = "Homebuyer";

$(document).ready(function () {

    $("#contact_modal_homebuyer_checkbox").on("change", function () {
        ContactUsFormModalProcessSubsource();
    });

    $("#contact_modal_agent_checkbox").on("change", function () {
        ContactUsFormModalProcessSubsource();
    });

    ContactUsFormModalProcessSubsource();
});

function ContactUsFormModalProcessSubsource() {
    var homebuyerCheckbox = document.getElementById("contact_modal_homebuyer_checkbox");
    var agentCheckbox = document.getElementById("contact_modal_agent_checkbox");
    var subSource = document.getElementById("contactUsFormModalSubSource");


    if (homebuyerCheckbox == null || agentCheckbox == null || subSource == null)
        return;

    if (homebuyerCheckbox.checked)
        subSource.value = contactUsFormModalHomebuyer;
    else if (agentCheckbox.checked)
        subSource.value = contactUsFormModalAgent;
    else
        subSource.value = "";
    console.log(subSource.value);
}


